/**
 * Copyright (c) 2021-22 Amway
 * @author Charu Agrawal
 */

import React, { Component } from "react";
import InputField from "../input-field";
import { getPreFillDataByContentKey } from "../../../utils/userResponse";
import _ from "lodash";
// Infterface for DropdownComponent Props
interface DropdownComponentProps {
  // close: () => void;
  list: any;
  //   handleOptionClick: () => void;
  dropdown_title?: string;
  dropdown_subTitle?: string;
  dropdown_placeHolder?: string;
  inputType?: string;
  inputValue?: (evt: any) => void;
  isError?: boolean;
  unit?: string;
  handleDropdownButtonChange?: (value: number, optionList: any) => void;
  id: any;
  isEmptySelected: boolean;
  errMsg: any;
  handleDropDownClick?: (value: any, outside: boolean) => void;
  isOpen?: boolean;
  recoId?: any;
  contentTypeId?: any;
}

// Infterface for DropdownComponent State
interface DropdownComponentState {
  inputValue: any;
  errorMsg?: string;
  openList: boolean;
  isError: boolean;
  inputType?: string;
  unit?: string;
}

/**
 * Dropdown Component
 *
 * @namespace DropdownComponent
 */

class DropdownComponent extends Component<
  DropdownComponentProps,
  DropdownComponentState
> {
  node: any;
  constructor(props: any) {
    super(props);
    this.state = {
      openList: false,
      inputValue: "",
      isError: false,
    };
  }

  /**
   * This method is used for handle dropdown functionality
   *
   */
  handleDropDown = (e: any) => {
    e.stopPropagation();
    if (!this.state.openList) {
      // attach/remove event handler
      document.addEventListener("click", this.handleOutsideClick);
      document.addEventListener("keydown", (e: any) => { if (e.key === "Escape") { this.handleOutsideClick(e) } }, true)
    } else {
      document.removeEventListener("click", this.handleOutsideClick);
      document.removeEventListener("keydown", (e: any) => { if (e.key === "Escape") { this.handleOutsideClick(e) } }, false)
    }

    if (this.props.handleDropDownClick) {
      this.props.handleDropDownClick(this.props.id, false);
    }
    // this.setState((prevState) => ({
    //   openList: !prevState.openList,
    // }));
  };
  handleDropDownOnKeyPress = (event: any) => {
    if (event.key === "Enter" || event.key === " ") {
      this.handleDropDown(event);
    }
  };

  /**
   * This method is used for handling dropdown outside click
   * @param {object} e
   *
   */
  handleOutsideClick = (e: any) => {
    e.stopPropagation();
    // ignore clicks on the component itself
    // if (this.node && this.node.contains(e.target)) {
    //   return;
    // }

    if (this.props.handleDropDownClick) {
      this.props.handleDropDownClick(this.props.id, true);
    }
    // this.setState({
    //   openList: false,
    // });
  };

  /**
   * This method is used handling input change
   * @param {any} evt
   */
  handleInputChange = (evt: any) => {
    this.setState({
      ...this.state,
      inputValue: evt.target.value,
    });
  };

  componentDidMount = () => {
    let reponseDataByType: any = getPreFillDataByContentKey(
      this.props.contentTypeId
    );
    this.setPreFillData(this.props.recoId, reponseDataByType);
  };

  /**
   * Used to set data as per users input(existing- if any)
   */
  setPreFillData = (recoId: string, data: any) => {
    let dataArray: any = data?.recoId;
    let recoIdIndex = _.findIndex(dataArray, function (id) {
      return id === recoId;
    });
    if (data && !_.isEmpty(data) && recoIdIndex >= 0) {
      let matchedRecoValue: any = data?.recoValues[recoIdIndex];
      _.map(this.props.list, (listItem, index) => {
        if (matchedRecoValue == listItem.id) {
          this.setState(
            {
              inputValue: listItem.value,
            },
            () => {
              if (this.props.handleDropdownButtonChange) {
                this.props.handleDropdownButtonChange(
                  this.props.id,
                  this.props.list[index]
                );
              }
            }
          );
        }
      });
    }
  };

  /**
   * This method is used handling option select
   * @param {number} index
   * @param {string} value
   *
   */
  handleSelect = (index: number, value: string) => {
    this.setState(
      {
        inputValue: value,
      },
      () => {
        if (this.props.handleDropdownButtonChange) {
          this.props.handleDropdownButtonChange(
            this.props.id,
            this.props.list[index]
          );
        }
      }
    );
  };
  /*This method is used handling keyboard press event option select*/
  handleSelectOnKeyPress = (event: any, index: number, value: string) => {
    if (event.key === "Enter" || event.key === " ") {
      this.handleSelect(index, value);
    }
  };

  render() {
    const {
      dropdown_title,
      dropdown_subTitle,
      dropdown_placeHolder,
      isEmptySelected,
      list,
      errMsg,
    } = this.props;
    const { empty_error } = errMsg || {};
    const { inputValue, isError } = this.state;

    /*This code will be required if search has to be enabled */
    // const filterDropdownData = list;
    // inputValue && inputValue.trim() && inputValue.trim().length > 0
    //   ? list.filter(
    //       (item: any) =>
    //         item &&
    //         item.value.toLowerCase() &&
    //         item.value
    //           .toLowerCase()
    //           .indexOf(inputValue && inputValue.toLowerCase()) !== -1
    //     )
    //   : list;

    return (
      <div
        className="input-wrapper dropdown-container"
        // onClick={this.handleDropDown}
        // onKeyPress={this.handleDropDownOnKeyPress}
      // ref={(node) => {
      //   this.node = node;
      // }}
      >
        <div className="dropdown-label">{dropdown_title || ""}</div>
        <div className="dropdown-sub-label">{dropdown_subTitle || ""}</div>
        <div
          className={
            isEmptySelected ? "option-wrapper error-wrapper" : "option-wrapper"
          }
          onClick={this.handleDropDown}
          onKeyPress={this.handleDropDownOnKeyPress}
        >
          <InputField
            type={""}
            placeHolder={dropdown_placeHolder || ""}
            className={
              isEmptySelected
                ? "custom-input error-input no-focus no-caplitalize"
                : "custom-input no-focus no-caplitalize"
            }
            handleInputChange={(evt) => {
              // this.handleInputChange(evt);
            }}
            inputValue={inputValue || ""}
            errorMsg={"Please select an option to continue"}
            isError={isError || false}
            readOnly
          />

          <div className={this.props.isOpen ? "arrowUp" : "arrowDown"}></div>
        </div>

        {/* dropdown list shown here */}
        <div className={this.props.isOpen ? "dropdown-options" : "hide"}>
          {list && list.length > 0
            ? list.map((item: any, index: number) => (
              <div
                key={index}
                tabIndex={0}
                role="listitem"
                className="dropdown-value input-wrapper"
                onClick={() => this.handleSelect(index, item.value)}
                onKeyPress={(e) =>
                  this.handleSelectOnKeyPress(e, index, item.value)
                }
              >
                {item.value}
              </div>
            ))
            : null}
        </div>
        <div tabIndex={0} className={isEmptySelected ? "error-msg" : "hide"}>
          {empty_error}
        </div>
      </div>
    );
  }
}

export default DropdownComponent;
